<template>
  <form v-if="!tabLoading" enctype="multipart/form-data">
    <div class="grid grid--rev" style="max-width: calc(100vw - 284px)">
      <div class="grid__cell col5-of-12--large-up"></div>
      <Form :data="branding" @code-change="brandingChange" />
    </div>
  </form>
</template>

<script>
import Form from '@/components/Dashboard/SettingsCodeForm';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/branding');

export default {
  components: {
    Form,
  },
  computed: {
    ...mapGetters(['branding']),
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  methods: {
    ...mapActions(['brandingChange']),
  },
};
</script>
